import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function EhrSearch() {
  const navigate = useNavigate();
  const [cxId, setCxId] = useState("");

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (cxId === "") return;
    navigate(`/ehr/${encodeURIComponent(cxId)}`);
  }

  return (
    <Box p={10}>
      <Box my={6}>
        <Heading size="lg">EHR Integrations</Heading>
      </Box>
      <form onSubmit={handleSubmit}>
        <VStack align="start" spacing={4} maxW="md">
          <FormControl>
            <FormLabel>Customer ID (cxId)</FormLabel>
            <Flex gap={2} align="center" justify="center">
              <Input
                value={cxId}
                onChange={e => setCxId(e.target.value.trim())}
                placeholder="Enter customer ID"
                bg="white"
                name="cxId"
                autoComplete="off"
              />
              <Button type="submit" colorScheme="blue" size="md">
                Search
              </Button>
            </Flex>
          </FormControl>
        </VStack>
      </form>
    </Box>
  );
}
